<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2676 21C10.4431 21.304 10.6956 21.5565 10.9996 21.732C11.3037 21.9075 11.6485 21.9999 11.9996 21.9999C12.3506 21.9999 12.6955 21.9075 12.9995 21.732C13.3036 21.5565 13.556 21.304 13.7316 21" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.9164 2.31402C13.0138 2.0099 12.0519 1.92498 11.11 2.0663C10.1682 2.20762 9.27353 2.57112 8.50001 3.12673C7.7265 3.68234 7.09635 4.41411 6.66169 5.26152C6.22703 6.10893 6.00034 7.04764 6.00036 8.00002C6.00036 12.499 4.58936 13.956 3.26036 15.327C3.12993 15.4704 3.04397 15.6485 3.01292 15.8398C2.98187 16.0311 3.00707 16.2273 3.08547 16.4045C3.16386 16.5818 3.29207 16.7324 3.45449 16.8381C3.61692 16.9438 3.80656 17.0001 4.00036 17H20.0004C20.1942 17.0001 20.3838 16.9438 20.5462 16.8381C20.7086 16.7324 20.8369 16.5818 20.9152 16.4045C20.9936 16.2273 21.0188 16.0311 20.9878 15.8398C20.9567 15.6485 20.8708 15.4704 20.7404 15.327C20.5346 15.1151 20.3393 14.8932 20.1554 14.662" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8C15 9.65685 16.3431 11 18 11Z" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71717A',
      required: false,
    },
  },
};
</script>
